import { SmartusComponentsModule } from '@affinis/smartus-components';
import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { DocumentTypeViewModel } from '@core/api';
import { MtxGridColumn } from '@ng-matero/extensions/grid';
import { TranslateService } from '@ngx-translate/core';
import {
  DataTableComponent,
  DEFAULT_TABLE_CONFIG,
  ITableConfig,
} from '@shared/components/data-table';
import { BehaviorSubject } from 'rxjs';

export interface IDialogData {
  title?: string;
  okButtonText?: string;
  dismissButtonText?: string;
  confirmColor?: string;
  cancelColor?: string;
  docTypes?: DocumentTypeViewModel[];
  docTypesCount?: number;
}

@Component({
  selector: 'app-add-document-types',
  imports: [
    CommonModule,
    SmartusComponentsModule,
    MatDialogModule,
    DataTableComponent,
  ],
  templateUrl: './add-document-types.component.html',
  styleUrl: './add-document-types.component.scss',
})
export class AddDocumentTypesComponent implements OnInit {
  config: ITableConfig = {
    ...DEFAULT_TABLE_CONFIG,
    rowSelectable: true,
    multiSelectable: true,
    filterFields: [
      {
        type: 'flex-layout',
        fieldGroup: [
          {
            key: 'name',
            type: 'input',
            props: {
              label: this.translateService.instant(
                'edit_document_types.doc_type'
              ),
            },
          },
        ],
      },
    ],
    filterOptions: {},
  };

  columns: MtxGridColumn[];

  public selectedRows$ = new BehaviorSubject<DocumentTypeViewModel[]>([]);
  selectedRowsChange$ = this.selectedRows$.asObservable();

  selection: DocumentTypeViewModel[] = [];

  constructor(
    public dialogRef: MatDialogRef<AddDocumentTypesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IDialogData,
    readonly translateService: TranslateService,
    readonly cd: ChangeDetectorRef
  ) {
    if (!data.confirmColor) {
      this.data.confirmColor = 'primary';
    }
    if (!data.cancelColor) {
      this.data.cancelColor = 'warn';
    }
  }

  ngOnInit() {
    this.columns = [
      {
        header: this.translateService.instant('edit_document_types.doc_type'),
        field: 'name',
        sortable: true,
      },
    ];
  }

  onRowSelectedChange(currentPageSelection: DocumentTypeViewModel[]) {
    const currentPageIds = currentPageSelection.map(row => row.documentTypeId);
    this.selectedRows$.next(
      this.selectedRows$.value.filter(
        row => !currentPageIds.includes(row.documentTypeId)
      )
    );

    this.selectedRows$.next([...currentPageSelection]);
  }

  submit() {
    this.dialogRef.close(this.selectedRows$.value);
  }
}
